import { apiPath } from "../api-path"
import apiIms from "./service-ims"

export async function getProfile() {
  return apiIms
    .get(apiPath.profile.base)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function updateProfile(data) {
  return apiIms
    .put(apiPath.profile.base, data)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}

export async function changePassword(data) {
  return apiIms
    .post(apiPath.profile.changePassword, data)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
      throw error
    })
}
